import AdaptiveImage from "../../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "quit.png",
    width: 250,
    height: 250
});